module.exports = __webpack_public_path__ + "static/media/hero-jpg.322ec8bb.jpg";